<script setup lang="ts">
import { ECMSType, ECMSPage, EHomePageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'
const { isTablet_rg, isMobile_lg } = useWindowWidth()
defineProps<{
	disableAos?: boolean
}>()
const features = ref<
	| {
			[key: string]: any
	  }[]
	| undefined
>()
const tiles = ref<
	| {
			[key: string]: any
	  }[]
	| undefined
>()

const { getLocaleLang } = usei18nService()

const pageSections = inject<Ref<IHomePageSectionModel[]>>('pageSections')

if (!pageSections) {
	try {
		const feat = await ApiService.fetchPageSectionByName(ECMSType.SUBPAGE, ECMSPage.HOME, EHomePageSectionType.FEATURES)
		if (feat) features.value = feat?.translations.find((t) => t.language === getLocaleLang())?.content
		const til = await ApiService.fetchPageSectionByName(ECMSType.SUBPAGE, ECMSPage.HOME, EHomePageSectionType.TILES)
		if (til) tiles.value = til?.translations.find((t) => t.language === getLocaleLang())?.content
	} catch (error) {
		console.log(error)
	}
}

watch(
	() => pageSections?.value,
	(newValue) => {
		if (newValue) {
			const section1 = newValue.find((section) => section.name === EHomePageSectionType.FEATURES)
			const section2 = newValue.find((section) => section.name === EHomePageSectionType.TILES)

			if (section1) {
				features.value = section1.translations.find((t) => t.language === getLocaleLang())?.content
			}
			if (section2) {
				tiles.value = section2.translations.find((t) => t.language === getLocaleLang())?.content
			}
		}
	},
	{ immediate: true, deep: true },
)
</script>

<template>
	<section class="number-one">
		<h2 :data-aos="disableAos ? undefined : 'fade-up'" class="number-one__title">
			{{ isMobile_lg ? $t('components.number_one.section.rental_nr_1_poland') : $t('components.number_one.section.rental_cars_nr_1_poland') }}
		</h2>
		<div class="number-one__container">
			<div :data-aos="disableAos ? undefined : 'fade-up'" data-aos-delay="200" class="number-one__card number-one__card--delivery">
				<div class="number-one__card-gradient"></div>
				<GlobalImage class="number-one__card-image" src="card-delivery.png" alt="delivery" :height="530" />
				<GlobalImage class="number-one__card-image-mask" src="card-delivery-mask.png" alt="delivery" :height="530" />
				<h3
					class="number-one__card-title number-one__card-title--delivery"
					v-html="tiles ? tiles[0].text : $t('components.number_one.section.delivery')"></h3>
				<div class="number-one__card-icon number-one__card-icon--lb">
					<GlobalIcon name="location" :width="isTablet_rg ? 20 : 24" />
				</div>
			</div>
			<div :data-aos="disableAos ? undefined : 'fade-up'" data-aos-delay="300" class="number-one__card number-one__card--24">
				<GlobalImage class="number-one__card-image-mask" alt="card-mask-24-1" src="card-mask-24-1.png" :height="530" />
				<GlobalImage class="number-one__card-image-mask" alt="card-mask-24-2" src="card-mask-24-2.png" :height="530" />
				<GlobalImage class="number-one__card-image-mask" alt="card-mask-24-3" src="card-mask-24-3.png" :height="530" />
				<h3 class="number-one__card-title number-one__card-title--24" v-html="tiles ? tiles[1].text : '24/7'"></h3>
				<div class="number-one__card-icon number-one__card-icon--lb number-one__card-icon--24">
					<GlobalIcon name="call-outline" :width="isTablet_rg ? 20 : 24" />
					<span class="number-one__card-icon-text">24/7</span>
				</div>
			</div>
			<div :data-aos="disableAos ? undefined : 'fade-up'" data-aos-delay="400" class="number-one__card number-one__card--unlimited">
				<GlobalImage class="number-one__card-image" alt="card-unlimited-v2" src="card-unlimited-v2.png" :height="530" />
				<GlobalImage class="number-one__card-image-mask" alt="card-unlimited-mask-v2" src="card-unlimited-mask-v2.png" :height="530" />
				<h3
					class="number-one__card-title number-one__card-title--unlimited"
					v-html="tiles ? tiles[2].text : $t('components.number_one.section.unlimited')"></h3>
				<div class="number-one__card-icon number-one__card-icon--lb">
					<GlobalIcon name="car" :width="isTablet_rg ? 20 : 24" />
				</div>
			</div>
		</div>
		<div class="number-one__container number-one__container--features">
			<GlobalNumberOneFeature
				v-for="(feature, i) in features"
				:key="i"
				:data-aos="disableAos ? undefined : 'fade-up'"
				data-aos-delay="200"
				:iconName="feature.icon"
				:feature-name="feature.name"
				:title="feature.text.toUpperCase()" />
		</div>
	</section>
</template>

<style lang="scss">
@import './Section';
</style>
